module.exports = __webpack_public_path__ + "media/img/logos/сorporate-f798d7e197e57e0d2547546d5f522e57.svg";